export default function () {
    var video = document.querySelector('#videoItem');
    var btntoggle = document.querySelector('#mute');
    if(btntoggle){
        btntoggle.addEventListener('click',function(){
            if (video.muted == true) {
                // Play the video
                video.muted = false

                // Update the button text to 'Pause'
                btntoggle.classList.toggle('muted');
              } else {
                // Pause the video
                video.muted = true

                // Update the button text to 'Play'
                btntoggle.classList.toggle('no-muted');
              }
        });
    }
}
